import { render, staticRenderFns } from "./PatientFollowUps.vue?vue&type=template&id=f2f44a78&"
import script from "./PatientFollowUps.vue?vue&type=script&lang=ts&"
export * from "./PatientFollowUps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports